module.exports = __webpack_public_path__ + "img/logo_pooling.05c27e42.svg";